import * as React from "react";
import type { SVGProps } from "react";
const SvgIconVideoDuotone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M19.16 3.24H4.84c-1.76 0-3.19 1.43-3.19 3.19v11.14c0 1.76 1.43 3.19 3.19 3.19h14.32c1.76 0 3.19-1.43 3.19-3.19V6.43c0-1.76-1.43-3.19-3.19-3.19"
      fill="#ECF1FF"
    />
    <path
      d="M9.31 15.7V9q0-.16.08-.32.09-.15.23-.23.15-.1.33-.08.17 0 .31.1L16 11.8q.15.08.23.23.08.14.08.32 0 .16-.08.31-.1.15-.23.24l-5.74 3.34q-.15.09-.31.09-.18 0-.32-.1-.15-.08-.24-.23-.08-.14-.08-.32"
      fill="white"
    />
    <path
      d="M9.31 15.7V9q0-.16.08-.32.09-.15.23-.23.15-.1.33-.08.17 0 .31.1L16 11.8q.15.08.23.23.08.14.08.32 0 .16-.08.31-.1.15-.23.24l-5.74 3.34q-.15.09-.31.09-.18 0-.32-.1-.15-.08-.24-.23-.08-.14-.08-.32"
      stroke="#5C5CFF"
      strokeWidth={1.71}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.16 3.24H4.84c-1.76 0-3.19 1.43-3.19 3.19v11.14c0 1.76 1.43 3.19 3.19 3.19h14.32c1.76 0 3.19-1.43 3.19-3.19V6.43c0-1.76-1.43-3.19-3.19-3.19"
      stroke="#5C5CFF"
      strokeWidth={1.71}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIconVideoDuotone;
